// extracted by mini-css-extract-plugin
export default {"noWrap":"required_text-module___noWrap___b7beb91a"};